import React from 'react';

interface IIconProps {
  className?: string;
}

const Icon = (props: IIconProps) => {
  const { className } = props;

  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h48v48H0z" />
        <path
          stroke="#4468FF"
          strokeWidth="3"
          d="M38 12H10l10.648 12.454.752 12.23 5.199-4.657.627-7.448z"
        />
      </g>
    </svg>
  );
};

export default React.memo(Icon);
